import { FC } from 'react';
import Heading from 'raydiant-elements/core/Heading';
import Column from 'raydiant-elements/layout/Column';
import ApplicationInputID from './ApplicationInputID';
import ApplicationInputRequired from './ApplicationInputRequired';
import ApplicationInputMultiline from './ApplicationInputMultiline';
import ApplicationInputMaxLength from './ApplicationInputMaxLength';
import ApplicationInputHelperText from './ApplicationInputHelperText';
import ApplicationInputHelperLink from './ApplicationInputHelperLink';
import ApplicationInputDefaultText from './ApplicationInputDefaultText';

interface ApplicationInputTypeTextProps {}

const ApplicationInputTypeText: FC<ApplicationInputTypeTextProps> = () => {
  return (
    <Column doubleMargin>
      <Column>
        <Heading overline size={5}>
          Properties
        </Heading>
        <ApplicationInputID />
        <ApplicationInputMultiline />
        <ApplicationInputDefaultText />
      </Column>

      <Column>
        <Heading overline size={5}>
          Validation
        </Heading>
        <ApplicationInputRequired />
        <ApplicationInputMaxLength />
      </Column>

      <Column>
        <Heading overline size={5}>
          Appearance
        </Heading>
        <ApplicationInputHelperText />
        <ApplicationInputHelperLink />
      </Column>
    </Column>
  );
};

export default ApplicationInputTypeText;
